import { gql } from 'graphql-request'

class UserQueries {
  getMe = gql`
    query getMe {
      me {
        id
        displayName
        buzzlUser {
          id
          role
          assignedCustomers {
            id
            name
          }
        }
        customerUser {
          id
          role
          customer {
            id
            nbRemainingLicenses
          }
        }
        email
        profilePicture {
          altText
          reference
          url
        }
      }
    }
  `

  checkUserExist = gql`
    query checkUserExist($where: UserExtendedWhereUniqueInput!) {
      user(where: $where) {
        id
        buzzlUser {
          id
        }
        customerUser {
          id
        }
      }
    }
  `

  getAnalytics = gql`
    query getAnalytics($where: AnalyticsWhereInput) {
      analytics(where: $where) {
        places {
          count
        }
        experiences {
          count
        }
        obtainedOffers {
          count
        }
        redeemedRewards: obtainedOffers(where: { redeemedAt_not: null, offer: { type: REWARD } }) {
          count
        }
        redeemedOffers: obtainedOffers(where: { redeemedAt_not: null, offer: { type: OFFER } }) {
          count
        }
        positiveExperiences: experiences(where: { evaluation: POSITIVE }) {
          count
        }
        neutralExperiences: experiences(where: { evaluation: NEUTRAL }) {
          count
        }
        negativeExperiences: experiences(where: { evaluation: NEGATIVE }) {
          count
        }
        verifiedExperiences: experiences(where: { isVerified: true, isValidated: false }) {
          count
        }
        validatedExperiences: experiences(where: { isValidated: true }) {
          count
        }
        experienceShared: trackingEvents(where: { type: EXPERIENCE_SHARED }) {
          count
        }
        placeViewed: trackingEvents(where: { type: PLACE_VIEWED }) {
          count
        }
        placeBtnClicked: trackingEvents(where: { type: PLACE_ACTION_BUTTON_CLICKED }) {
          count
        }
      }
    }
  `
}

const userQueries = new UserQueries()

export default userQueries
